module.exports = __webpack_public_path__ + "static/media/onboarding-training.c543013a.svg";